import hyperHTML from 'hyperhtml';
import pickerTemplate from './template-picker';

const calculateInputClasses = (state) => {
  const classes = ['e-input e-daterange__picker'];

  if (state.disabled) {
    classes.push('e-input-disabled');
  }

  if (state.invalid) {
    classes.push('e-input-error');
  }

  if (state.opened && state.overlay) {
    classes.push('e-daterange__picker-active');
  }

  return classes.join(' ');
};

const getActivePresetValue = (state) => {
  if (state.presetsHidden || !state.start.displayedValue || !state.end.displayedValue) {
    return '';
  }

  const activePresetIndex = Object.keys(state.presets).filter(index => {
    const preset = state.presets[index];
    return preset.start === state.start.value && preset.end === state.end.value;
  });

  if (!state.presets[activePresetIndex]) {
    return 'Custom Range';
  }

  return state.presets[activePresetIndex].name;
};

const getRangeValue = (state) => {
  if (state.start.displayedValue && state.end.displayedValue) {
    return hyperHTML.wire()`
      <e-time datetime=${state.start.value} format="date"></e-time>
      <span> &ndash; </span>
      <e-time datetime=${state.end.value} format="date"></e-time>
    `;
  }
  return '';
};

const clearButton = (state, events) => hyperHTML.wire()`
  <button class="e-daterange__clear" onclick=${events.clear}></button>
`;

export default (render, state, events) => {
  const hasClearButton = !state.noClear && !state.disabled && (state.start.value || state.end.value);

  if (state.layout === 'inline') {
    pickerTemplate(render, state, events);
  } else {
    render`
      <div class="${calculateInputClasses(state)}" onclick="${events.open}">
        <e-icon icon="calendar-o"></e-icon>
        <span class="e-daterange__value">${getRangeValue(state)}</span>
        <span class="e-daterange__range">${getActivePresetValue(state)}</span>
        ${hasClearButton ? clearButton(state, events) : '' }
      </div>
    `;
  }
};
